import { render, staticRenderFns } from "./GdDropdownContent.vue?vue&type=template&id=2f54a974"
import script from "./GdDropdownContent.vue?vue&type=script&lang=js"
export * from "./GdDropdownContent.vue?vue&type=script&lang=js"
import style0 from "./GdDropdownContent.vue?vue&type=style&index=0&id=2f54a974&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports